import axios from 'axios';
import * as Constants from "../common/constants";
import { AnatomicalSystemModel } from "../models/anatomicalSystem/anatomicalSystemModel";
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';

class AnatomicalSystemService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}

	}

	getAllAnatomicalSystems() {
		return axios({
			url: `adminAnatomicalSystem/getAll/`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getAnatomicalSystem(id: number) {
		return axios({
			url: `adminAnatomicalSystem/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addAnatomicalSystem(anatomicalSystem: AnatomicalSystemModel) {
		return axios({
			url: `adminAnatomicalSystem/createAnatomicalSystem`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(anatomicalSystem)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editAnatomicalSystem(id: number, anatomicalSystem: AnatomicalSystemModel) {
		return axios({
			url: `adminAnatomicalSystem/updateAnatomicalSystem/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(anatomicalSystem)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteAnatomicalSystem(id: number) {
		return axios({
			url: `adminAnatomicalSystem/deleteAnatomicalSystem/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default AnatomicalSystemService;
